import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"

import "./company.vue?vue&type=style&index=0&id=62050080&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62050080"]])

export default __exports__